// extracted by mini-css-extract-plugin
export default {"view":"ShooterView_view__6oRFK","header":"ShooterView_header__MpYar"};